if (!customElements.get('product-sticky-bar')) {
  class ProductStickyBar extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.details = this.querySelectorAll('.product-variant-accordion details');
      this.openButton = this.querySelector('.product-sticky-bar__opener__open');
      this.closeButton = this.querySelector('.product-sticky-bar__opener__close');

      this.hideVisibleButtons = this.hasAttribute('hide-visible');
      this.defaultButton = document.querySelector('.product__info-container .product-form__buttons');

      const isFinePointer = window.matchMedia('(pointer: fine)').matches;

      this.bindOnResize = this.onResize.bind(this);
      const onWindowScroll = this.onWindowScroll.bind(this);
      const throttledScroll = throttle(onWindowScroll, 100);
      const trailingScroll = debounce(onWindowScroll, 100);
      this.bindOnWindowScroll = () => {
        throttledScroll();
        trailingScroll();
      };

      this.setInfoHeight();
      setTimeout(() => {
        this.setBarHeight();
      }, 305)

      this.details.forEach(detail => {
        const summary = detail.querySelector('summary')
        const content = detail.querySelector('.accordion__content');

        if (summary) summary.addEventListener('click', this.onDetailsSummaryClick.bind(this, detail))
        if (content && isFinePointer) this.setVariantFieldsetMouseDrag(content)
      })

      if (this.openButton) this.openButton.addEventListener('click', this.openBar.bind(this));
      if (this.closeButton) this.closeButton.addEventListener('click', this.closeBar.bind(this));

      if (this.hideVisibleButtons && this.defaultButton) {
        this.onWindowScroll();
        window.addEventListener('scroll', this.bindOnWindowScroll, { passive: true });
      }

      this.resizeTimeout = null;
      window.addEventListener('resize', this.bindOnResize);

      this.setObservers(() => {
        this.setBarHeight();
      });
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.bindOnResize);
      if (this.hideVisibleButtons && this.defaultButton) {
        window.removeEventListener('scroll', this.bindOnWindowScroll, { passive: true });
      }
      this.disconnectObservers();
      if (this.barHeightFrame) cancelAnimationFrame(this.barHeightFrame);
    }

    openBar() {
      this.setAttribute('open', true);
    }

    closeBar() {
      this.removeAttribute('open');
      this.details.forEach(detail => {
        if (detail.open == true) this.closeVariant(detail)
      })
    }

    onDetailsSummaryClick(target) {
      this.setDropdownHeight(target);

      target.classList.add('opening')
      setTimeout(() => {
        this.details.forEach(detail => {
          if (detail != target && detail.open == true) this.closeVariant(detail)
        })
      }, 200);
      setTimeout(() => {
        target.classList.remove('opening')
      }, 500)
    }

    setDropdownHeight(detail) {
      const openDetail = detail ? detail : this.querySelector('.product-variant-accordion details[open]');
      this.style.setProperty('--opened-height', `${openDetail ? openDetail.dataset.contentHeight : 0}px`)
    }

    setBarHeight() {
      const rect = this.getBoundingClientRect();
      const height = Math.max(0, Math.min(rect.bottom, window.innerHeight) - Math.max(rect.top, 0));

      if (this.barHeightFrame) cancelAnimationFrame(this.barHeightFrame);
      this.barHeightFrame = requestAnimationFrame(() => {
        this.barHeightFrame = null;
        document.documentElement.style.setProperty('--product-sticky-bar-height', `${height}px`);
      });
    }

    setInfoHeight() {
      this.style.setProperty('--info-height', `${this.querySelector('.product-sticky-bar__info').clientHeight}px`)
    }

    closeVariant(detail) {
      detail.classList.add('closing');
      detail.querySelector('summary').setAttribute('aria-expanded', 'false')
      setTimeout(() => {
        detail.removeAttribute('open')
        detail.classList.remove('closing')
      }, 305)
    }

    setVariantFieldsetMouseDrag(fieldset) {
      if (!fieldset) return;

      let isDown = false;
      let startX = 0;
      let startY = 0;
      let scrollLeft = 0;
      let scrollTop = 0;

      const mouseMove = (event) => {
        event.preventDefault();
        if (!isDown) return;

        fieldset.classList.add('moving');

        const x = event.pageX - fieldset.offsetLeft;
        const walkX = x - startX;
        fieldset.scrollLeft = scrollLeft - walkX;

        const y = event.pageY - fieldset.offsetTop;
        const walkY = y - startY;
        fieldset.scrollTop = scrollTop - walkY;
      }

      const mouseUp = () => {
        isDown = false;
        fieldset.classList.remove('grabbing');
        fieldset.classList.remove('moving');

        fieldset.removeEventListener('mousemove', mouseMove, { passive: false })
        fieldset.removeEventListener('mouseup', mouseUp, { passive: false })
        fieldset.removeEventListener('mouseleave', mouseUp, { passive: false })
      }

      const mouseDown = (event) => {
        fieldset.classList.add('grabbing');
        isDown = true;
        startX = event.pageX - fieldset.offsetLeft;
        startY = event.pageY - fieldset.offsetTop;
        scrollLeft = fieldset.scrollLeft;
        scrollTop = fieldset.scrollTop;

        fieldset.addEventListener('mousemove', mouseMove, { passive: false })
        fieldset.addEventListener('mouseup', mouseUp, { passive: false })
        fieldset.addEventListener('mouseleave', mouseUp, { passive: false })
      }

      fieldset.addEventListener('mousedown', mouseDown, { passive: false })
    }

    onResize() {
      this.setDropdownHeight();
      this.setInfoHeight();
    }

    onWindowScroll() {
      const rect = this.defaultButton.getBoundingClientRect();
      if (rect.top < window.innerHeight && rect.bottom > 0) {
        if (!this.classList.contains('hide')) {
          this.classList.add('hide');
          this.details.forEach(detail => {
            if (detail.open == true) this.closeVariant(detail)
          })
        }
      } else {
        if (this.classList.contains('hide')) {
          this.classList.remove('hide');
        }

        if (rect.bottom >= window.innerHeight) {
          this.classList.add('above-buy-buttons');
        } else {
          this.classList.remove('above-buy-buttons');
        }
        if (rect.bottom <= 20) {
          this.classList.add('under-buy-buttons');
        } else {
          this.classList.remove('under-buy-buttons');
        }
      }

    }

    setObservers(callback) {
      this.resizeObserver = new ResizeObserver(() => callback('size'));
      this.resizeObserver.observe(this);

      const info = this.querySelector('.product-sticky-bar__info');
      if (info) {
        this.mutationObserver = new MutationObserver(() => callback('content'));
        this.mutationObserver.observe(info, { childList: true, subtree: true });
      }

      this.intersectionObserver = new IntersectionObserver(() => callback('position'), {
        threshold: [0, 0.01, 0.99, 1]
      });
      this.intersectionObserver.observe(this);

      this.onTransitionEnd = (event) => {
        if (event.propertyName === 'transform') callback('position');
      };
      this.transitionWrapper = this.querySelector('.product-sticky-bar__content-wrapper');
      this.addEventListener('transitionend', this.onTransitionEnd);
      if (this.transitionWrapper) this.transitionWrapper.addEventListener('transitionend', this.onTransitionEnd);
    }

    disconnectObservers() {
      if (this.resizeObserver) this.resizeObserver.disconnect();
      if (this.mutationObserver) this.mutationObserver.disconnect();
      if (this.intersectionObserver) this.intersectionObserver.disconnect();
      if (this.onTransitionEnd) {
        this.removeEventListener('transitionend', this.onTransitionEnd);
        if (this.transitionWrapper) this.transitionWrapper.removeEventListener('transitionend', this.onTransitionEnd);
      }
    }
  }

  customElements.define('product-sticky-bar', ProductStickyBar)
}